import React, {useEffect, useState} from "react";
import { Box, Stack, Typography, Card, CardContent, Button, Divider } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { FlexStart, FlexEnd, FlexCenter } from "components/FlexBox/FlexBox";
import ImageGallery from 'components/Images/ImageGallery';
import WifiOutlinedIcon from "@mui/icons-material/WifiOutlined";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import FitnessCenterOutlinedIcon from "@mui/icons-material/FitnessCenterOutlined";
import LockIcon from '@mui/icons-material/Lock';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import ElevatorIcon from '@mui/icons-material/Elevator';
import PoolIcon from '@mui/icons-material/Pool';
import SendIcon from '@mui/icons-material/Send';
import ImageUploader from "components/Images/ImageUploader";
import EditIcon from '@mui/icons-material/Edit';
import FlexBetween from "components/FlexBetween";
import FormDialog from "components/modal";
import RentalsEditForm from "components/Forms/RentalsEditForm";
import axios from "axios";
import { baseURL } from "services/API";
import { useSelector } from "react-redux";
import * as yup from 'yup';
import TopSnack from "components/TopSnack";


const facilityIcons = {
	marginRight: "8px",
	fontSize: "20px",
	color: "#52524e",
};

const coloredIconGreen = {
	marginRight: "8px",
	fontSize: "20px",
	color: "#0af047",
};

const coloredIconRed = {
	marginRight: "8px",
	fontSize: "20px",
	color: "#f20a0a",
};

const detailsText = {
	fontSize: "16px",
	fontWeight: 600,
	padding: "5px"
}

const descriptionText = {
	fontSize: "15px",
	fontWeight: 400,
	fontStyle: "italic"
}

const PropertyDetails = ({propertyDetails, newChange, setNewChange}) => {
  const token = useSelector((state) => state.token)
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  const id = useSelector((state) => state.property_id);
  const [tempRef, setTempRef] = useState(0)
  const [open, setOpen] = React.useState(false);
  const [images, setImages] = useState([])
  const [defaultImages, setDefaultImages] = useState(true) 

  const [submittingFiles, setSubmittingFiles] = useState(false)
  const [files, setFiles] = useState([]);

  const [loadingPropertyDetails, setLoadingPropertyDetails] = useState(true)
  const [rentalName, setRentalName] = useState(propertyDetails.rental_name)
  const [propertyUse, setPropertyUse] = useState(propertyDetails.rental_type)
  const [propertyLocation, setPropertyLocation] = useState(propertyDetails.location)
  const [locationCounty, setLocationCounty] = useState(propertyDetails.location_county)
  const [security, setSecurity] = useState(propertyDetails.security)
  const [hospitalAccess, setHospitalAccess] = useState(propertyDetails.hospital_access)
  const [roadAccess, setRoadAccess] = useState(propertyDetails.main_road_access)
  const [parking, setParking] = useState(propertyDetails.has_parking)
  const [fibre, setFibre] = useState(propertyDetails.has_fibre)
  const [elevator, setElevator] = useState(propertyDetails.has_elevator)
  const [gym, setGym] = useState(propertyDetails.has_gym)
  const [pool, setPool] = useState(propertyDetails.has_swimming_pool)
  const [openSnack, setOpenSnack] = useState({open:false, message:"", severity:""})
 
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack({ ...openSnack, open: false });
  };
 

  const fetchImages = async () => {
	try {
		const response = await axios.get(`${baseURL}/landlords/rentals/images?rental_id=${id}`);
		if(response.data.data.length > 0) {
			setImages(response.data.data)
			setDefaultImages(false)
		} else {
			setImages(response.data.data)
			setDefaultImages(true)
		}
		setLoadingPropertyDetails(false);
	} catch (e) {
		setLoadingPropertyDetails(false);
	}
  } 

  useEffect(() => {
	fetchImages()
  }, [tempRef])

  const handleClickOpen = () => {
	setOpen(true);
  };

  const handleClose = () => {
	setOpen(false);
	setErrors({});
  };

  const handleChangeRentalName = (event) => {
	const {value} = event.target
	setRentalName(value);
	if (!value.trim()) {
		setErrors((prev) => ({ ...prev, 'rental_name': `Property Name is required`}));
	} else {
		setErrors((prev) => ({ ...prev, "rental_name": "" }));
	}
};

  const handleChangePropertyUse = (event) => {
	setPropertyUse(event.target.value);
  };

  const handleChangeLocation = (event) => {
	setPropertyLocation(event.target.value);
  };

  const handleChangeLocationCounty = (event) => {
	setLocationCounty(event.target.value);
  };

  const handleChangeSecurity = (event) => {
	setSecurity(event.target.checked);
  };

  const handleChangeHospitalAccess = (event) => {
	setHospitalAccess(event.target.checked);
  };

  const handleChangeRoadAccess = (event) => {
	setRoadAccess(event.target.checked);
  };

  const handleChangeParking = (event) => {
	setParking(event.target.checked);
  };

  const handleChangeFibre = (event) => {
	setFibre(event.target.checked);
  };

  const handleChangeElevator = (event) => {
	setElevator(event.target.checked);
  };

  const handleChangeGym = (event) => {
	setGym(event.target.checked);
  };

  const handleChangePool = (event) => {
	setPool(event.target.checked);
  };

  	const [errors, setErrors] = React.useState({});
	const propertySchema = yup.object().shape({
		rental_name: yup.string().required("Please enter the property name"),
		location: yup.string().required("Input a parish or county in the selected City"),
		rental_type: yup.string().required("Select the property type"),
	});


  const handleRentalEditFormSubmit = async () => {
	try {
		await propertySchema.validate({rental_name: rentalName, rental_type: propertyUse, 	location: propertyLocation}, {abortEarly:false});
	} catch (error) {
		const newError = {}
		error.inner.forEach(err => {
			newError[err.path]=err.message
		})
		setErrors(newError)
		return
	}

	try {
		await axios.post(`${baseURL}/landlords/rentals/details?rental_id=${id}`, {
			rental_name: rentalName,
			rental_type: propertyUse,
			location: propertyLocation,
			location_county: locationCounty,
			has24_security: security,
			has_gym: gym,
			has_swimming_pool: pool,
			hospital_access: hospitalAccess,
			main_road_access: roadAccess,
			has_elevator: elevator,
			has_fibre: fibre,
			has_parking: parking
		});
		setOpen(false);
		setOpenSnack({
			open: true,
			message: "Operation Successful",
			severity: "success",
		});
		setNewChange(newChange+1);
	} catch (err) {
		console.log(err);
		setOpenSnack({
			open: true,
			message: "Please fill all fields",
			severity: "error",
		});
	}
 };

 const handleRentalFileUploadSubmit = async (file) => {
	try {
		const formData = new FormData();
		formData.append("image", file);
		formData.append("related_rental", id);
		
		await axios.post(`${baseURL}/landlords/rentals/images`, formData);
		
	} catch (err) {
		console.log(err);
	}
	setTempRef(tempRef + 1);
 }; 

 const submitFiles = () => {
	setSubmittingFiles(true)
	files.map(async (file) => {
		await handleRentalFileUploadSubmit (file)
	})
	setSubmittingFiles(false)
	setTempRef(prev=>prev+1)
	setFiles([])
 }


  return (
    <Box>
        <Grid container spacing={2} marginTop="10px">
			<Grid item xs={12} sm={6}>
				<Stack spacing={3} sx={{ marginBottom: "20px" }}>
					{defaultImages ? (
						<Typography variant="h5" color="red" justifyContent="center" it>No Images Available</Typography>
					) : (
						<ImageGallery imageList={images} defaultImages={defaultImages}/>
					)}
					
					<FlexBetween>
						{/* <Typography variant="h3">Property Details</Typography> */}
						<Typography variant="h3">Facilities</Typography>
						
						<FlexEnd onClick={handleClickOpen} sx={{
							cursor: "pointer"
						}}>
							<Typography variant="h5" sx={{color:"#0759e8"}}>Edit Details</Typography>
							<EditIcon sx={facilityIcons} />
						</FlexEnd>
					</FlexBetween>
					
					<Box sx={{ border: "1px solid rgba(0, 0, 0, 0.12)", borderRadius: "4px", padding: "1rem" }}>
						<Grid container spacing={2}>
							<Grid xs={12} sm={6}>
								<Stack spacing={2}>
									<FlexCenter>
										<LockIcon sx={facilityIcons} />
										<Typography>Has 24 Hour Security?</Typography>
										{propertyDetails.has24_security ? (							<CheckCircleIcon sx={coloredIconGreen} />
										) : (
											<ClearIcon sx={coloredIconRed} />
										)}
										
									</FlexCenter>
									<FlexCenter>
										<FitnessCenterOutlinedIcon sx={facilityIcons} />
										<Typography>Has a Gym?</Typography>
										{propertyDetails.has_gym ? (										<CheckCircleIcon sx={coloredIconGreen} />
										) : (
											<ClearIcon sx={coloredIconRed} />
										)}
									</FlexCenter>
									<FlexCenter>
										<LocalPharmacyIcon sx={facilityIcons} />
										<Typography>Hospital Access in less than 10 Minutes</Typography>
										{propertyDetails.hospital_access ? (										<CheckCircleIcon sx={coloredIconGreen} />
										) : (
											<ClearIcon sx={coloredIconRed} />
										)}
									</FlexCenter>
									<FlexCenter>
										<AddRoadIcon sx={facilityIcons} />
										<Typography>Main Road Access in less than 5 minutes</Typography>
										{propertyDetails.main_road_access ? (												<CheckCircleIcon sx={coloredIconGreen} />
										) : (
											<ClearIcon sx={coloredIconRed} />
										)}
									</FlexCenter>
								</Stack>
							</Grid>
							<Grid xs={12} sm={6}>
								<Stack spacing={2}>
									<FlexCenter>
										<DirectionsCarFilledOutlinedIcon sx={facilityIcons} />
										<Typography>Has Ample Parking Space</Typography>
										{propertyDetails.has_parking ? (												<CheckCircleIcon sx={coloredIconGreen} />
										) : (
											<ClearIcon sx={coloredIconRed} />
										)}
									</FlexCenter>
									<FlexCenter>
										<WifiOutlinedIcon sx={facilityIcons} />
										<Typography>Has Fibre/Wifi</Typography>
										{propertyDetails.has_fibre ? (												<CheckCircleIcon sx={coloredIconGreen} />
										) : (
											<ClearIcon sx={coloredIconRed} />
										)}
									</FlexCenter>
									<FlexCenter>
										<PoolIcon sx={facilityIcons} />
										<Typography>Has Swimming Pool</Typography>
										{propertyDetails.has_swimming_pool ? (												<CheckCircleIcon sx={coloredIconGreen} />
										) : (
											<ClearIcon sx={coloredIconRed} />
										)}
									</FlexCenter>
									<FlexCenter>
										<ElevatorIcon sx={facilityIcons} />
										<Typography>Has Elevator</Typography>
										{propertyDetails.has_elevator ? (												<CheckCircleIcon sx={coloredIconGreen} />
										) : (
											<ClearIcon sx={coloredIconRed} />
										)}
									</FlexCenter>
								</Stack>
							</Grid>
						</Grid>
					</Box>
				</Stack>
			</Grid>
			
			<Grid item sx={{ display: { xs: "none", sm: "block" } }} xs={12} sm={5}>
					<Card sx={{ position: "sticky", top: 0 }}>
						<CardContent sx={{ padding: 0 }}>
							<FlexStart sx={{ padding: "16px" }}>
							{/* <LandLordAvatar /> */}
								<Box sx={{ marginLeft: "8px" }}>
									<Typography variant="body1" sx={{ fontSize: "17px" }}>
										Add Property Images
									</Typography>
								</Box>
							</FlexStart>
							<Divider />
							<Stack spacing={3} sx={{ padding: "16px" }}>
								<ImageUploader files={files} setFiles={setFiles} maxFiles={3}/>
							</Stack>
							<Stack spacing={3} sx={{ padding: "16px" }}>
								{files.length > 0 && (
									<>
									{submittingFiles ? (
										<Button variant="outlined" loading>Submitting Images for Review</Button>
									) : (
										<Button variant="outlined" endIcon={<SendIcon />} onClick={submitFiles}>Submit Images for Review</Button>
									)}
									</>
								)}
							</Stack>
						</CardContent>
					</Card>
				</Grid>
		</Grid>
		<FormDialog
			open={open}
			handleClose={handleClose}
			enableActions={true}
			content={
				<RentalsEditForm
					rentalName={rentalName}
					handleChangeRentalName={handleChangeRentalName}
					propertyUse={propertyUse}
					handleChangePropertyUse={handleChangePropertyUse}
					location={propertyLocation}
					handleChangeLocation={handleChangeLocation}
					locationCounty={locationCounty}
					handleChangeLocationCounty={handleChangeLocationCounty}
					security={security}
					handleChangeSecurity={handleChangeSecurity}
					hospitalAccess={hospitalAccess}
					handleChangeHospitalAccess={handleChangeHospitalAccess}
					roadAccess={roadAccess}
					handleChangeRoadAccess={handleChangeRoadAccess}
					parking={parking}
					handleChangeParking={handleChangeParking}
					fibre={fibre}
					handleChangeFibre={handleChangeFibre}
					elevator={elevator}
					handleChangeElevator={handleChangeElevator}
					gym={gym}
					handleChangeGym={handleChangeGym}
					pool={pool}
					errors={errors}
					handleChangePool={handleChangePool}
				/>
			}
			title={"Edit Property Details"}
			handleSubmit={handleRentalEditFormSubmit}
			buttonText="submit"
		/>
		<TopSnack open={openSnack.open} message={openSnack.message} severity={openSnack.severity} handleCloseSnack={handleCloseSnack}/>
    </Box>
  );
};

export default PropertyDetails;